import { Action, createReducer, on } from '@ngrx/store';
import * as AllocateServiceWizardStoreActions from './actions';
import { State, initialState } from './state';

export const allocateServiceWizardStoreFeatureKey = 'allocateServiceWizardStoreV26';

const allocateServiceWizardStoreReducer = createReducer(
  initialState,

  on(AllocateServiceWizardStoreActions.selectInitStep, (state, { initStep: userStep }) => ({
    ...state,
    initStep: userStep,
    dueDatesStep: { activationDate: null, deactivationDate: null },
  })),
  on(AllocateServiceWizardStoreActions.selectDueDatesStep, (state, { dueDatesStep }) => ({
    ...state,
    dueDatesStep,
  })),
  // on(AllocateServiceWizardStoreActions.selectLicenseStep, (state, { licenseStep }) => ({
  //   ...state,
  //   licenseStep,
  // })),
  // on(AllocateServiceWizardStoreActions.selectAdditionalStep, (state, { addInfoStep }) => ({
  //   ...state,
  //   addInfoStep,
  // })),
  on(AllocateServiceWizardStoreActions.exitAllocateServiceWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
  })),
  on(AllocateServiceWizardStoreActions.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return allocateServiceWizardStoreReducer(state, action);
}
